import React, { useCallback, useState } from "react"
import { Modal, Grid } from "antd"
import { ResponsivePage } from "ui/ResponsivePage"
import { useNavigate } from "react-router-dom"
import GroupMenuItems from "pagesV2/pro/clients/ClientWindow/GroupManager/GroupMenuItems"
import { useDispatch, useSelector } from "react-redux"
import { getGroups } from "store/groups"
import { useTranslation } from "react-i18next"
import { UnsavedChangesModal } from "ui/UnsavedChangesModal"

const ClientManageGroup = () => {
  const [isGroupManagerModalVisible, setIsGroupManagerModalVisible] = useState(true)
  const navigate = useNavigate()
  const { useBreakpoint } = Grid
  const screens = useBreakpoint()
  const isMobile = !screens.md
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const groups = useSelector((state) => state.groups?.items || [])
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false)
  const [showUnsavedModal, setShowUnsavedModal] = useState(false)

  const handleClose = () => {
    if (hasUnsavedChanges) {
      setShowUnsavedModal(true)
      return
    }
    navigate(-1)
  }
  
  const handleCloseModal = () => {
    if (hasUnsavedChanges) {
      setShowUnsavedModal(true)
      return
    }
    setIsGroupManagerModalVisible(false)
    navigate(-1)
  }
  
  const executeClose = () => {
    setShowUnsavedModal(false)
    setIsGroupManagerModalVisible(false)
    navigate(-1)
  }
  const handleGroupsChange = useCallback(() => {
    dispatch(getGroups())
    setIsGroupManagerModalVisible(false)
  }, [dispatch])

  return (
    <>
      {isMobile ? (
        <ResponsivePage onBackClick={handleClose} pageTitle={t("clients.manage_groups")}>
          <GroupMenuItems onGroupsChange={handleGroupsChange} groups={groups} onUnsavedChangesChange={setHasUnsavedChanges} />
        </ResponsivePage>
      ) : (
        <Modal
          title={t("clients.manage_groups")}
          open={isGroupManagerModalVisible}
          onCancel={handleCloseModal}
          footer={null}
          width={{ xxl: 800, xl: 700 }}
        >
          <GroupMenuItems onGroupsChange={handleGroupsChange} groups={groups} onUnsavedChangesChange={setHasUnsavedChanges} />
        </Modal>
      )}

      <UnsavedChangesModal
        open={showUnsavedModal}
        onDiscard={executeClose}
        onKeepEditing={() => setShowUnsavedModal(false)}
        zIndex={1200}
      />
    </>
  )
}

export default ClientManageGroup
